(function() {

  setInterval(function time(){
    var d = new Date();
    var d1 = new Date();
    d.setHours(d1.getHours() + 12)
    var hours = 24 - d.getHours();
    var min = 60 - d.getMinutes();
    if((min + '').length == 1){
      min = '0' + min;
    }
    var sec = 60 - d.getSeconds();
    if((sec + '').length == 1){
          sec = '0' + sec;
    }
    $('.timer').html(hours+'hrs '+min+'m '+sec+ 's')
  }, 1000);
  
  var currentDate = new Date(new Date().getTime() + 336 * 60 * 60 * 1000);
  var currentDateNew = new Date(new Date().getTime() + 336 * 60 * 60 * 1000);
  var day = currentDateNew.getDate()
  let dayN="th";
  switch (day) {
    case 1:
      dayN = "st";
      break;
    case 2:
      dayN = "nd";
      break;
    case 3:
      dayN = "rd";
      break;
    default:
      dayN = "th";
  }
  var month = currentDate.getMonth() + 1
  var year = currentDate.getFullYear()
  var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  $(".date-product").html(days[currentDateNew.getDay()] + " " + day + dayN +" "  + monthNames[currentDateNew.getMonth()])

  
    function myFunctionFooterMenu(x) {
      if (x.matches) { // If media query matches
        $(".footer__block-list > div > p").click(function(){
          let $this = $(this)
          $(this).toggleClass("activated")
          $(this).next().slideToggle("fast")
          $(this).next().next().slideToggle("fast")
          $(this).next().next().next().slideToggle("fast")
        })
      }
    }
    var x = window.matchMedia("(max-width: 767.98px)")
    myFunctionFooterMenu(x) // Call listener function at run time
    x.addListener(myFunctionFooterMenu) // Attach listener function on state changes

  $(document).on('click', '#custom-load-more__btn', function(e) {
    e.preventDefault();
    const urlToFetch = $(this).attr('data-href');
    $(this).parent().remove();
    $.get(urlToFetch, function(data) {
        var $fetchedHtml = $(data);
        var $elementToAppend = $fetchedHtml.find('.product-list').html();

        $('.product-list').append($elementToAppend);
    });
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function () {
  function initSizeSlider() {
    const selectors = document.querySelectorAll('div[data-option-selector]');

    selectors.forEach((el) => {
      const hasCmOption = [...el.querySelectorAll('input')].some(input =>
        (input.value || '').includes('cm')
      );

      if (!hasCmOption) return;
      if (el.dataset.raSliderInitialized === 'true') return;

      el.dataset.raSliderInitialized = 'true';

      const wrapper = document.createElement('div');
      wrapper.className = 'ra-size-slider-wrap';

      const leftBtn = document.createElement('button');
      leftBtn.type = 'button';
      leftBtn.className = 'ra-size-slider-btn ra-size-slider-btn--left';
      leftBtn.setAttribute('aria-label', 'Previous sizes');
      leftBtn.innerHTML = '&#8249;';

      const rightBtn = document.createElement('button');
      rightBtn.type = 'button';
      rightBtn.className = 'ra-size-slider-btn ra-size-slider-btn--right';
      rightBtn.setAttribute('aria-label', 'Next sizes');
      rightBtn.innerHTML = '&#8250;';

      const track = document.createElement('div');
      track.className = 'ra-size-slider-track';

      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(leftBtn);
      wrapper.appendChild(track);
      wrapper.appendChild(rightBtn);
      track.appendChild(el);

      function updateButtons() {
        const maxScrollLeft = el.scrollWidth - el.clientWidth;
        leftBtn.disabled = el.scrollLeft <= 5;
        rightBtn.disabled = el.scrollLeft >= maxScrollLeft - 5;
      }

      function getScrollAmount() {
  const firstItem = el.querySelector('label, .block-swatch');
  if (!firstItem) return el.clientWidth * 0.8;
  const styles = window.getComputedStyle(el);
  const gap = parseInt(styles.columnGap || styles.gap || 10, 10);
  return firstItem.offsetWidth + gap;
}

leftBtn.addEventListener('click', function () {
  el.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
});

rightBtn.addEventListener('click', function () {
  el.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
});


      el.addEventListener('scroll', updateButtons);
      window.addEventListener('resize', updateButtons);

      setTimeout(updateButtons, 300);
      updateButtons();
    });
  }

  initSizeSlider();

  const observer = new MutationObserver(() => {
    initSizeSlider();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[style]').forEach(function (el) {
    var s = el.getAttribute('style');
    if (s && /9[Bb]8670/.test(s)) {
      el.setAttribute('style', s.replace(/#9[Bb]8670/gi, '#7A6555'));
    }
  });
});